export default class ProjectItem {
    private _title: string;
    private _meta: Array<string>;
    private _description: string | undefined;
    private _url: string;

    constructor(title: string, meta: Array<string>, url: string, description?: string) {
        this._title = title;
        this._meta = meta;
        this._description = description;
        this._url = url;
    }

    public get title(): string {
        return this._title
    }
    public get meta(): Array<string> {
        return this._meta
    }
    public get description(): string | undefined {
        return this._description
    }
    public get url(): string {
        return this._url
    }
}